module.exports = __webpack_public_path__ + "static/media/SM.79e6b9c2.png";